import React, { useEffect, useState } from "react";
import AuthModal from "./AuthModal";
import ProfileModal from "./ProfileModal";
import { Link, useNavigate } from "react-router-dom";

const Header = () => {
  const [authMode, setAuthMode] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [showProfile, setShowProfile] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const savedUser = localStorage.getItem("currentUser");

    if (savedUser) {
      setCurrentUser(JSON.parse(savedUser));
    }
  }, []);

  const handleLogin = (user) => {
    setCurrentUser(user);
  };

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("currentUser");
    setCurrentUser(null);
    setShowProfile(false);
    setMobileMenuOpen(false);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();

    const query = searchQuery.trim();

    if (!query) {
      setSearchOpen((prev) => !prev);
      return;
    }

    navigate(`/search?q=${encodeURIComponent(query)}`);
    setSearchOpen(false);
    setMobileMenuOpen(false);
  };

  return (
    <>
      <header
        className={`main-header glass-card ${
          mobileMenuOpen ? "mobile-menu-open" : ""
        }`}
      >
        <div className="header-right">
          <Link to="/" className="brand-link" onClick={closeMobileMenu}>
            <div className="brand-logo-box">
              <img
                src="/main_logo.png"
                alt="چشم هوشمند آموزش"
                className="brand-logo-img"
              />
            </div>

            <div className="brand-text-box">
              <h2>چشم هوشمند آموزش</h2>
              <span>آموزش | تکنولوژی | هوش مصنوعی</span>
            </div>
          </Link>
        </div>

        <button
          type="button"
          className={`mobile-nav-toggle ${mobileMenuOpen ? "active" : ""}`}
          onClick={() => setMobileMenuOpen((prev) => !prev)}
          aria-label="باز و بسته کردن منو"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`main-nav ${mobileMenuOpen ? "is-open" : ""}`}>
          <Link to="/" onClick={closeMobileMenu}>
            خانه
          </Link>

          <Link to="/news" onClick={closeMobileMenu}>
            اخبار
          </Link>

          <Link to="/courses" onClick={closeMobileMenu}>
            دوره‌ها
          </Link>

          <a
            href="https://iemict.ir"
            target="_blank"
            rel="noreferrer"
            onClick={closeMobileMenu}
          >
            شرکت مادر
          </a>

          <Link to="/about" onClick={closeMobileMenu}>
            درباره ما
          </Link>

          <Link to="/contact" onClick={closeMobileMenu}>
            تماس با ما
          </Link>

          <form
            className={`header-search ${searchOpen ? "is-open" : ""}`}
            onSubmit={handleSearchSubmit}
            role="search"
          >
            <button
              type="button"
              className="header-search-toggle"
              aria-label="جستجو"
              onClick={() => setSearchOpen((prev) => !prev)}
            >
              <svg
                className="header-search-icon"
                viewBox="0 0 24 24"
                aria-hidden="true"
                focusable="false"
              >
                <circle cx="11" cy="11" r="6.2" />
                <path d="M16.2 16.2 21 21" />
              </svg>
            </button>

            {searchOpen && (
              <input
                value={searchQuery}
                onChange={(event) => setSearchQuery(event.target.value)}
                placeholder="جستجو در اخبار و دوره‌ها"
                autoFocus
              />
            )}
          </form>
        
          
        </nav>

        <div className="header-left">
          {currentUser ? (
            <>
              <span className="user-welcome">
                {currentUser.firstName} خوش آمدید
              </span>

              <button
                className="btn btn-profile"
                onClick={() => setShowProfile(true)}
              >
                پروفایل
              </button>
            </>
          ) : (
            <>
              <button
                className="btn btn-secondary"
                onClick={() => setAuthMode("login")}
              >
                ورود
              </button>

              <button
                className="btn btn-primary"
                onClick={() => setAuthMode("register")}
              >
                ثبت‌نام
              </button>
            </>
          )}
        </div>
      </header>

      {authMode && (
        <AuthModal
          mode={authMode}
          onClose={() => setAuthMode(null)}
          onLogin={handleLogin}
        />
      )}

      {showProfile && currentUser && (
        <ProfileModal
          user={currentUser}
          onClose={() => setShowProfile(false)}
          onLogout={handleLogout}
        />
      )}
    </>
  );
};

export default Header;